import liff from '@line/liff';

const LIFF_ID = import.meta.env.VITE_LIFF_ID as string;

let initialized = false;

export async function initLiff() {
  if (initialized) return;
  if (!LIFF_ID) throw new Error('VITE_LIFF_ID is not configured');
  await liff.init({ liffId: LIFF_ID });
  initialized = true;
}

export function ensureLogin() {
  if (!liff.isLoggedIn()) {
    liff.login({ redirectUri: window.location.href });
    return false;
  }
  return true;
}

export async function getProfile() {
  return liff.getProfile();
}

export function getIdToken(): string | null {
  return liff.getIDToken();
}

export function logout() {
  liff.logout();
  window.location.reload();
}

export { liff };
